import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyProductModal from './BuyProductModal';
import CardAttachModal from './CardAttachModal';
import CreateCompanyModal from '../../company/CreateCompanyModal'
import BuyConProductModal from './BuyConProductModal';

class PricingModal extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        }
    }

    render() {
        const { userData, priceCard, companyData, alu, isTopup, storeInfo } = this.props;
        const { companyPaymentAccess } = alu;
        if (companyData) {
            const { accessMap } = companyData;
            const ueid = userData.uid + userData.employeeid;
            var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
            if (companyPaymentAccess[accessLevel]) {
                const proceedDirectlyToPayments = "stripeDefaultPmid" in companyData ? companyData.stripeDefaultPmid === "" ? false : true : false;

                return (
                    <React.Fragment>
                        {/* <p>{JSON.stringify(storeInfo)}</p> */}
                        {proceedDirectlyToPayments ? isTopup ? <BuyConProductModal priceCard={priceCard} storeInfo={storeInfo} /> : <BuyProductModal priceCard={priceCard} storeInfo={storeInfo} /> : <CardAttachModal />}
                    </React.Fragment>
                );
            } else {
                return (
                    <React.Fragment>
                        <p>You are not authorized to take this action. Please ask the admin of this company for this.</p>
                    </React.Fragment>
                );
            }
        } else {
            return (
                <React.Fragment>
                    <CreateCompanyModal />
                </React.Fragment>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.firebase.profile,
        companyData: state.firestore.data.Company,
        alu: state.alu,
    }
}


export default connect(mapStateToProps)(PricingModal);